export default "__VITE_ASSET__DzU74ja7__"